export default "__VITE_ASSET__Cxp0aaIJ__"